import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel, CarouselHorizontalScrollCarouselItem } from "@faire/retailer-visitor-shared/components/Carousel/Carousel";
import { ProductImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductImage";
import { ProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductTile";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { observer } from "mobx-react";
import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
var ProductPreviewCarouselBase = function(props) {
    var productTiles = props.productTiles, brandToken = props.brandToken, className = props.className, moreProductCount = props.moreProductCount;
    var viewport = useViewport();
    var history = useHistory();
    var itemsPerSlide = useResponsiveValue({
        mobileAndAbove: 2,
        tabletAndAbove: 3,
        desktopAndAbove: 3,
        xLargeAndAbove: 4
    });
    var handleSignUp = useCallback(function() {
        return popSignUp(history, SignUpType.FAIRE_DIRECT, function() {
            return null;
        }, {
            element: SignUpElement.CAROUSEL,
            sourceId: "fd_landing_product_preview_carousel"
        });
    }, [
        history
    ]);
    var renderItem = function(productTile) {
        var isLastItem = props.productTiles.length > 0 && productTile === props.productTiles.slice(-1)[0];
        var bestProductImage = productTile.best_image;
        if (isLastItem && bestProductImage && moreProductCount) {
            var _productTile_product, _productTile_product1;
            return /*#__PURE__*/ _jsx(SpecialTile, {
                onClick: handleSignUp,
                children: /*#__PURE__*/ _jsx(ProductImage, {
                    image: bestProductImage,
                    imageDimension: {
                        mobileAndAbove: 80,
                        tabletAndAbove: 250
                    },
                    alt: ((_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.description) || (productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.name) || "",
                    extraProductsCount: moreProductCount
                })
            });
        } else {
            var _productTile_product2;
            return /*#__PURE__*/ _jsx(ProductTile, {
                productTile: productTile,
                generateProductLinkProps: function() {
                    return undefined;
                },
                imageDimension: {
                    mobileAndAbove: 80,
                    tabletAndAbove: 250
                }
            }, productTile === null || productTile === void 0 ? void 0 : (_productTile_product2 = productTile.product) === null || _productTile_product2 === void 0 ? void 0 : _productTile_product2.token);
        }
    };
    return /*#__PURE__*/ _jsx(StyledCarousel, {
        className: className,
        padItems: true,
        name: "fd-landing/".concat(brandToken, "/product-list"),
        items: productTiles,
        noWrap: true,
        peekNext: viewport.isMobile,
        itemGap: 8,
        itemsPerSlide: itemsPerSlide,
        renderItem: renderItem,
        buttonsOffsetTop: "calc(50% - 50px)"
    });
};
export var ProductPreviewCarousel = observer(ProductPreviewCarouselBase);
var SpecialTile = styled.div.withConfig({
    componentId: "sc-78d8fb74-0"
})([
    "cursor:pointer;height:fit-content;"
]);
var StyledCarousel = styled(Carousel).withConfig({
    componentId: "sc-78d8fb74-1"
})([
    "width:calc(100% + 40px);margin:0 -20px;",
    ";overflow-y:hidden;",
    "{overflow-y:unset;width:100%;margin:0;}",
    "{padding:0 4px;&:last-child{padding:0 20px 0 4px;}}"
], "" /* This hides the horizontal scrollbar on mobile */ , responsiveMediaQueries.tabletAndAbove, CarouselHorizontalScrollCarouselItem);
